(function () {

    angular
        .module('smartertoolsApp')
        .factory('pricequotes', ['$http', 'refreshToken', '$log', 'cacheControl', '$q', '$rootScope', pricequotes]);

    function pricequotes($http, refreshToken, $log, cacheControl, $q, $rootScope) {
        var urlBase = apiRootUrl;
        var getPriceQuotesPromise;

        var dataFactory = {};
        dataFactory.getPriceQuotes = getPriceQuotes;
        dataFactory.sendThroughEmail = sendThroughEmail;
        dataFactory.payInvoiceZero = payInvoiceZero;
        dataFactory.payInvoiceLater = payInvoiceLater;
        dataFactory.payExistingCard = payExistingCard;
        dataFactory.payNewCard = payNewCard;
        return dataFactory;

        // -----------------------------------------------

        function getPriceQuotes() {
            if (getPriceQuotesPromise)
                return getPriceQuotesPromise;
            getPriceQuotesPromise = refreshToken.refreshToken()
                .then(() => $http.get(urlBase + 'v1/account/pricequotes/all', {cache: cacheControl.getCache('invoiceCache')}))
                .then(function (response) {
                    getPriceQuotesPromise = null;
                    return response.data.PriceQuotes;
                })
                .catch(function (err) {
                    getPriceQuotesPromise = null;
                    $q.reject(err);
                });
            return getPriceQuotesPromise;
        }

        function sendThroughEmail(priceQuoteGuid, emailAddress) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/pricequotes/send-email',
                    JSON.stringify({PriceQuoteGuid: priceQuoteGuid, EmailAddress: emailAddress})))
                .then((response) => response.data);
        }

        function payInvoiceZero(priceQuoteGuid) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/pricequotes/pay-zero', JSON.stringify({PriceQuoteGuid: priceQuoteGuid})))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function payInvoiceLater(priceQuoteGuid) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/pricequotes/pay-invoice-later', JSON.stringify({PriceQuoteGuid: priceQuoteGuid})))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function payExistingCard(priceQuoteGuid, paymentMethod) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/pricequotes/pay-existing-card',
                    JSON.stringify({
                        PriceQuoteGuid: priceQuoteGuid,
                        PaymentMethodId: paymentMethod.PaymentMethodId,
                        SecurityCode: paymentMethod.SecurityCode
                    })))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }

        function payNewCard(priceQuoteGuid, paymentMethod) {
            return refreshToken.refreshToken()
                .then(() => $http.post(urlBase + 'v1/account/pricequotes/pay-new-card',
                    JSON.stringify({
                        PriceQuoteGuid: priceQuoteGuid,
                        CardNumber: paymentMethod.CardNumber,
                        NameOnCard: paymentMethod.NameOnCard,
                        ExpirationMonth: paymentMethod.ExpirationMonth,
                        ExpirationYear: paymentMethod.ExpirationYear,
                        SecurityCode: paymentMethod.SecurityCode,
                        Country: paymentMethod.Country,
                        Address1: paymentMethod.Address1,
                        Address2: paymentMethod.Address2,
                        City: paymentMethod.City,
                        State: paymentMethod.State,
                        ZipCode: paymentMethod.ZipCode,
                        SaveCard: paymentMethod.SaveCard
                    })))
                .then((response) => {
                    cacheControl.clearAllCaches();
                    $rootScope.$broadcast('cache-clear', {});
                    return response.data;
                });
        }
    }

})();